import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNewTranslation } from 'hooks'
import { TeamState } from 'state/teams'
import { MemberState, deleteMember, removeTeamMember } from 'state/teams'
import { MODAL_TYPE } from '.'
import Modal from 'particles/Modal'

interface RemoveAndDeleteMemberProps {
    onClose: () => void
    team?: TeamState
    type: MODAL_TYPE
    member: MemberState
}
const RemoveAndDeleteMember: React.FC<RemoveAndDeleteMemberProps> = ({ onClose, team, type, member }) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()
    const isDeleteMode = type === MODAL_TYPE.DELETE_MEMBER
    const onDeleteMember = useCallback(() => {
        member && dispatch(deleteMember({ teamUuid: team?.uuid, memberUuid: member.uuid }))
    }, [member])

    const onRemoveTeamMember = useCallback(
        () => member && dispatch(removeTeamMember({ teamUuid: team?.uuid, memberUuid: member.uuid })),
        [member],
    )

    const handleCloseModal = (e: any): void => {
        if (e.target.id === 'pop-up-delete-modal') {
            onClose()
        }
    }

    useEffect(() => {
        window.addEventListener('click', handleCloseModal)
        return (): void => window.removeEventListener('click', handleCloseModal)
    }, [])

    return (
        <>
            {team ? (
                <Modal
                    title={t(
                        `${
                            isDeleteMode
                                ? 'modalWindow.allTeams.deactivateAccountWindowTitle'
                                : 'modalWindow.allTeams.removeMemberWindowTitle'
                        }`,
                        {
                            teamName: team?.name,
                        },
                    )}
                    subtext={t(
                        `${
                            isDeleteMode
                                ? 'modalWindow.allTeams.deactivateAccountWindowSubtitle'
                                : 'modalWindow.allTeams.removeMemberWindowSubtitle'
                        }`,
                        {
                            email: member?.email,
                            teamName: team?.name,
                        },
                    )}
                    onClose={onClose}
                    onConfirm={() => {
                        if (isDeleteMode) {
                            onDeleteMember()
                        } else {
                            onRemoveTeamMember()
                        }
                        onClose()
                    }}
                    secondaryButtonProps={{
                        label: t('button.noCancel'),
                    }}
                    primaryButtonProps={{
                        label: isDeleteMode ? t('button.yesDelete') : t('button.yesRemove'),
                    }}
                    size="m"
                    hasIcon={false}
                />
            ) : null}
        </>
    )
}

export default RemoveAndDeleteMember
